import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

export interface WhatsappBusinessProfile {
  about?: string;
  address?: string;
  description?: string;
  email?: string;
  profile_picture_url?: string;
  websites?: string[];
  vertical?: string;
}

type QueryResponse = {
  status: number;
  data: WhatsappBusinessProfile;
};

export const createWhatsappProfileKey = (additional: any[] = []) => [
  'whatsapp-profile',
  ...additional,
];

export const useGetWhatsappProfileQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while fetching WhatsApp Profile',
    endpoint: `/api/admin/whatsapp/profile`,
  });

  return useQuery({
    queryKey: createWhatsappProfileKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};